import { render, staticRenderFns } from "./pages1.vue?vue&type=template&id=ae0add06&scoped=true&"
import script from "./pages1.vue?vue&type=script&lang=js&"
export * from "./pages1.vue?vue&type=script&lang=js&"
import style0 from "./pages1.vue?vue&type=style&index=0&id=ae0add06&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae0add06",
  null
  
)

export default component.exports